import { getCurrentMQ } from "../helper/domHelper";
import { MQ_CHANGE_EVENT } from '../constants/eventNames';

export default class MediaQueryService {
  constructor() {
    this.lastMQ = getCurrentMQ();
    window.addEventListener("resize", () => this.handleMQChange());
  }

  static getInstance() {
    if (this.instance === undefined) {
      this.instance = new MediaQueryService();
    }
    return this.instance;
  }

  handleMQChange() {
    const newMQ = getCurrentMQ();
    if (newMQ === this.lastMQ) {
      return;
    }
    
    window.dispatchEvent(
      new CustomEvent(MQ_CHANGE_EVENT, {
        detail: {
          newMQ,
          oldMQ: this.lastMQ,
        },
      }),
    );

    this.lastMQ = newMQ;
  }
}